<template>
  <div class="create_wrapper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("addNew") }}</h4>
      </div>

      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateCreateForm">
        <div class="container">
          <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-3">
            <!-- Start:: Image  -->
            <div class="md:tw-col-span-2">
              <template v-if="data.image">
                <uplode-image
                  :data_src="data.image"
                  @inputChanged="uplodeImg_1"
                  :placeHolder="$t('forms.labels.image')"
                ></uplode-image>
              </template>
              <template v-else>
                <uplode-image
                  @inputChanged="uplodeImg_1"
                  :placeHolder="$t('forms.labels.image')"
                ></uplode-image>
              </template>
            </div>
            <!-- End:: Image -->

            <!-- Start:: fullname -->

            <div class="input_wrapper top_label">
              <input
                type="text"
                class="form-control"
                @input="helper_checkIfInputIsEmpty"
                v-model.trim="data.fullname"
              />
              <label for="name_input" class="form-label">الاسم الكامل</label>
            </div>

            <!-- End:: fullname -->

            <!-- Start:: phone -->

            <div class="input_wrapper top_label">
              <input
                type="number"
                min="0"
                class="form-control"
                @input="helper_checkIfInputIsEmpty"
                v-model.trim="data.phone"
              />
              <label for="name_input" class="form-label">رقم الهاتف</label>
            </div>

            <!-- End:: phone  -->

            <!-- Start:: Email -->

            <div class="input_wrapper top_label">
              <input
                type="email"
                class="form-control"
                @input="helper_checkIfInputIsEmpty"
                v-model.trim="data.email"
              />
              <label for="name_input" class="form-label"
                >البريد الالكتروني</label
              >
            </div>

            <!-- End:: Email  -->
            <div class="md:tw-col-span-2">
              <h5>النوع</h5>

              <div class="tw-flex tw-items-center">
                <div class="solution_form">
                  <input
                    type="radio"
                    class="form-check-input"
                    name="gender"
                    id="male"
                    value="male"
                    v-model="data.gender"
                  />
                  <label for="male">
                    ذكر
                    <!-- <img class="solution_image" src="@/assets/images/solution/solution1.png" /> -->
                  </label>
                </div>
                <div class="solution_form">
                  <input
                    type="radio"
                    class="form-check-input"
                    name="gender"
                    id="female"
                    value="female"
                    v-model="data.gender"
                  />
                  <label for="female">
                    أنثي
                    <!-- <img class="solution_image" src="@/assets/images/solution/solution2.png" /> -->
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="buttons_wrapper">
          <button class="base-btn" :class="btnIsLoading ? 'disabled' : ''">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "add/Edit",

  data() {
    return {
      dateMenu: false,
      dateMenu2: false,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.profile.title"),
          disabled: false,
          href: "/settings/profile",
        },
        {
          text: this.$t("breadcrumb.profile.add&edit"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== create_data
      data: {
        image: null,
        fullname: null,
        gender: null,
        email: null,
        phone: null,
      },
    };
  },

  methods: {
    // Uplode Image
    uplodeImg_1(obj) {
      this.data.image = obj;
    },

    // Validate Data
    validateCreateForm() {
      this.btnIsLoading = true;
      if (!this.data.image) {
        this.$iziToast.error({
          timeout: 2000,
          message: "الصورة مطلوبة",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.fullname) {
        this.$iziToast.error({
          timeout: 2000,
          message: "أدخل الاسم الكامل",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.phone) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.phone"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (this.data.phone.length < 9) {
        this.$iziToast.error({
          timeout: 2000,
          message: "رقم الهاتف يجب ان يكون اكبر من 9 ارقام",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (this.data.phone.length > 11) {
        this.$iziToast.error({
          timeout: 2000,
          message: "رقم الهاتف يجب ان يكون اقل من 11 رقم",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.email) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.email"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.gender) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.gender"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();
        return;
      }
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();
      if (this.data.image.img_file) {
        submit_data.append("image", this.data.image?.img_file);
      }

      submit_data.append("fullname", this.data.fullname);
      submit_data.append("email", this.data.email);

      submit_data.append("phone", this.data.phone);
      submit_data.append("gender", this.data.gender);

      submit_data.append("_method", "PUT");

      this.axios({
        method: "POST",
        url: "profile/update",
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/settings/profile" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
    getData() {
      this.axios({
        method: "GEt",
        url: "profile/show",
      })
        .then((res) => {
          if (res.data.data) {
            this.data = res.data.data;
          }
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
  },

  mounted() {
    this.getData();
  },
};
</script>
<style lang="scss" scoped>
.solution_form {
  label {
    padding: 8px 15px;
    padding-inline-start: 40px;
    font-size: 14px;
    color: var(--light_gray_clr);
    border-radius: 6px;
    background: var(--white_clr);
    border: 2px solid transparent;
    cursor: pointer;
    position: relative;
    width: 100%;
    &::before {
      content: "";
      width: 30px;
      height: 30px;
      border-radius: 50%;
      border: 1px solid var(--mainColor-2_2);
      display: inline-block;
      inset: 0;
      position: absolute;
    }
    &::after {
      content: "";
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: #fff;
      display: inline-block;
      inset: 5px;
      position: absolute;
      transition: all 1px linear;
    }
  }
  input {
    display: none;
    &:checked + label::after {
      background: var(--mainColor-2_2);
    }
  }
}
</style>
